import cookies from "js-cookie";

export const useToken = () => {
  // debugger
  let token = cookies.get("token");
  if (!token) {
    token =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjp7ImxvZ25hbWUiOiJTVVBFUl9BRE1JTiJ9LCJpYXQiOjE2OTA0Njk2MTJ9.f3kv5zYaDTvEYhfB9N5Nw8egdhfMGJBmxnas_5nCvzU"; // это админ
    // "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL3Rwb3J0YWwudmF6LnJ1IiwiYXVkIjoiaHR0cDovL21ybS5zZW90bHQucnUvYXBpL3YxL2F1dGgiLCJkYXRhIjp7ImxvZ25hbWUiOiJQTkFMWUFFIn19.lwzGhxKvdG5Xcc9szTZgwZAQ7-bXNQoqEFGl2RM7nk4"; // это dealer
    // "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJkYXRhIjp7ImxvZ25hbWUiOiJZMTI5OTU4In19.7tbY8a6szZ0SQW9eWiIk-xilzT9v7szhPUfH4z32nac"; // это админ даты
    // location.replace("https://tportal.vaz.ru/");
  }

  return { token };
};
